module.exports = __webpack_public_path__ + "static/media/direction_sign_illustration_s_s.725df344.jpg";